// 'Jul 31, 2023 20:01:00' --> lunes

/**
 * HORARIO PARA EL TEST
 *
 * Lunes a Viernes de 9:00 a 20:00
 * Sábados de 10:00 a 17:00
 * Domingos de 10:00 a 14:00
 */

import { createRingpoolElement } from './createRingpoolElement'
import { pickElementById } from './utils'

// export const testDate = 'Jan 15, 2024 21:00:00'

export const WEEK_MOMENTS = {
  WEEKDAY: 'weekday',
  SATURDAY: 'saturday',
  SUNDAY: 'sunday'
}

const urlsWithoutRingpool = ['segurosdevida.allianz.es'] // 9:00 - 20:00
const { host } = window.location

/**
 * Si es sabado o domingo la función retorna false
 */
export const checkDay = () => {
  const currentMoment = new Date()
  const day = currentMoment.getDay()

  if (day === 0) return WEEK_MOMENTS.SUNDAY
  if (day === 6) return WEEK_MOMENTS.SATURDAY
  return WEEK_MOMENTS.WEEKDAY
}

export const checkHour = (options) => {
  const currentMoment = new Date()
  const { start, end, customMinutes } = options
  const hour = currentMoment.getHours()
  const minutes = currentMoment.getMinutes()

  if (hour >= start && hour <= end && minutes <= customMinutes) {
    return true
  }

  if (hour >= start && hour < end) {
    return true
  }

  return false
}

export function deleteELementsWithRingpool(inbound = false) {
  const DRPselectors = ['ringpoolDesktop', 'llamanosId', 'ringPoolCha']
  const waitForDRP = setInterval(() => {
    if (typeof window.DRP !== 'undefined') {
      clearInterval(waitForDRP)

      DRPselectors.forEach((selector) => {
        if (document.getElementById(selector) !== null) {
          document.getElementById(selector).style.display = 'none'
          window.DRP.stopRingPool()
        }
      })

      const renderingInbound = () => {
        const inboundNumber = '919498182'
        if (pickElementById('ringPoolCha')) {
          pickElementById('ringPoolCha').setAttribute(
            'href',
            `tel:${inboundNumber}`
          )
        }
      }

      if (inbound) renderingInbound()
    }
  }, 50)
}

export function deleteOutHoursDRP() {
  if (urlsWithoutRingpool.includes(host)) {
    deleteELementsWithRingpool(true)
  }

  /**
   * CASE 1: De Lunes a Viernes DENTRO del horario 9:00 a 20:00 ✅
   */

  if (
    checkDay() === WEEK_MOMENTS.WEEKDAY &&
    checkHour({
      start: 9,
      end: 20,
      customMinutes: 0
    })
  ) {
    createRingpoolElement({
      number: window.DFI.telefonoRingPoolActivo ?? '91 949 81 77'
    })
    // console.log('CASE 1: De Lunes a Viernes DENTRO del horario 9:00 a 20:00')
  }

  

  /**
   * CASE 2: Sábado DENTRO del horario 10:00 a 17:00 ❌
   */

  /**
   * CASE 3: Domingo DENTRO del horario 10:00 a 14:00 ❌
   */

  /**
   *! CASE 4: De Lunes a Viernes FUERA del horario 9:00 a 20:00
   */

  if (
    checkDay() === WEEK_MOMENTS.WEEKDAY &&
    !checkHour({
      start: 9,
      end: 20,
      customMinutes: 0
    })
  ) {
    deleteELementsWithRingpool()
    // console.log('CASE 4: De Lunes a Viernes FUERA del horario 9:00 a 20:00')
  }

  /**
   * !CASE 5: Sábado FUERA del horario 10:00 a 17:00
   */
  if (
    checkDay() === WEEK_MOMENTS.SATURDAY &&
    checkHour({
      start: 10,
      end: 17,
      customMinutes: 0
    })
  ) {
    createRingpoolElement({
      number: window.DFI.telefonoRingPoolActivo ?? '91 949 81 77'
    })
    // console.log('CASE 1: De Lunes a Viernes DENTRO del horario 9:00 a 20:00')
  }

  if (checkDay() === WEEK_MOMENTS.SATURDAY &&
  !checkHour({
    start: 10,
    end: 17,
    customMinutes: 0
  })) {
    deleteELementsWithRingpool()
    // console.log('CASE 5: Sábado FUERA del horario 10:00 a 17:00')
  }

  /**
   * !CASE 6: Domingo FUERA del horario 10:00 a 14:00
   */

  if (checkDay() === WEEK_MOMENTS.SUNDAY) {
    deleteELementsWithRingpool()
    // console.log('CASE 6: Domingo FUERA del horario 10:00 a 14:00')
  }
}

export function configRingpoolForModalPage() {
  /**
   * !CASE 1: De Lunes a Viernes FUERA del horario 9:00 a 20:00
   */

  if (
    checkDay() === WEEK_MOMENTS.WEEKDAY &&
    !checkHour({
      start: 9,
      end: 20,
      customMinutes: 0
    })
  ) {
    deleteELementsWithRingpool()
    // console.log('CASE 1: De Lunes a Viernes FUERA del horario 9:00 a 20:00')
  }

  /**
   * !CASE 2: Sábado FUERA del horario 10:00 a 17:00
   */

  if (checkDay() === WEEK_MOMENTS.SATURDAY) {
    deleteELementsWithRingpool()
    console.log('CASE 2: Sábado FUERA del horario 10:00 a 17:00')
  }

  /**
   * !CASE 3: Domingo FUERA del horario 10:00 a 14:00
   */

  if (checkDay() === WEEK_MOMENTS.SUNDAY) {
    deleteELementsWithRingpool()
    // console.log('CASE 3: Domingo FUERA del horario 10:00 a 14:00')
  }
}
